export default __webpack_public_path__ + "static/media/svg-6.e8cf2136.svg";